// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { AnimatePresence, motion } from 'framer-motion';

// const HomeGlyph = () => (
//   <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M3 10.5 12 3l9 7.5" />
//     <path d="M5 9.5V21h14V9.5" />
//     <path d="M9 21v-6h6v6" />
//   </svg>
// );

// const ResetGlyph = () => (
//   <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M3 12a9 9 0 1 0 3-6.7" />
//     <path d="M3 4v5h5" />
//   </svg>
// );

// const AttachGlyph = () => (
//   <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="m21.44 11.05-8.49 8.49a6 6 0 0 1-8.49-8.49l9.19-9.2a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 1 1-2.82-2.83l8.49-8.48" />
//   </svg>
// );

// const CloseGlyph = () => (
//   <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
//     <path d="m6 6 12 12" />
//     <path d="M18 6 6 18" />
//   </svg>
// );

// const Bubble = ({
//   role,
//   children,
//   wide = false,
//   primaryColor = '#d95b0a',
//   accentColor = '#f26a00',
//   themeMode = 'light',
//   textSize = 14,
//   textColor = '',
// }) => {
//   const isUser = role === 'user';
//   const botBg = themeMode === 'dark' ? '#0f172a' : '#ffffff';
//   const botBorder = themeMode === 'dark' ? 'rgba(148,163,184,0.24)' : '#e2e8f0';
//   const botText = textColor || (themeMode === 'dark' ? '#e5e7eb' : '#1e293b');

//   return (
//     <div className={`flex min-w-0 w-full ${isUser ? 'justify-end' : 'justify-start'}`}>
//       <div
//         className={[
//           'min-w-0 max-w-[82%] overflow-hidden break-words rounded-[24px] px-4 py-3 text-sm leading-6 shadow-lg backdrop-blur-sm [overflow-wrap:anywhere]',
//           wide ? 'w-full' : '',
//           isUser
//             ? 'rounded-br-[8px] text-white shadow-orange-400/20'
//             : 'rounded-bl-[8px]',
//         ].join(' ')}
//         style={isUser
//           ? { background: `linear-gradient(135deg, ${primaryColor} 0%, ${accentColor} 100%)`, fontSize: `${textSize}px` }
//           : { background: botBg, border: `1px solid ${botBorder}`, color: botText, fontSize: `${textSize}px` }}
//       >
//         {children}
//       </div>
//     </div>
//   );
// };

// const TypingDots = () => (
//   <div className="flex items-center gap-1.5 py-1">
//     {[0, 1, 2].map((index) => (
//       <motion.span
//         key={index}
//         className="h-2.5 w-2.5 rounded-full bg-emerald-300/90"
//         animate={{ y: [0, -3, 0], opacity: [0.35, 1, 0.35] }}
//         transition={{
//           duration: 0.9,
//           repeat: Infinity,
//           ease: 'easeInOut',
//           delay: index * 0.14,
//         }}
//       />
//     ))}
//   </div>
// );

// const MediaContent = ({ message, themeMode }) => {
//   const mediaUrl = String(message?.mediaUrl || '').trim();
//   if (!mediaUrl) return null;
//   const mediaType = String(message?.mediaType || message?.type || 'image').toLowerCase();
//   const label = message?.alt || message?.text || 'Bot attachment';

//   if (mediaType === 'video') {
//     return (
//       <video controls preload="metadata" className="mb-2 max-h-64 w-full rounded-2xl bg-black object-contain">
//         <source src={mediaUrl} />
//         Your browser cannot play this video.
//       </video>
//     );
//   }

//   if (mediaType === 'file') {
//     return (
//       <a
//         href={mediaUrl}
//         target="_blank"
//         rel="noreferrer"
//         className="mb-2 block rounded-xl border px-3 py-2 text-sm font-semibold underline"
//         style={{ borderColor: themeMode === 'dark' ? 'rgba(148,163,184,0.3)' : '#dbe4f0' }}
//       >
//         {label || 'Open attachment'}
//       </a>
//     );
//   }

//   return (
//     <img
//       src={mediaUrl}
//       alt={label}
//       loading="eager"
//       className="mb-2 max-h-72 w-full rounded-2xl object-cover"
//     />
//   );
// };

// const toLocalDateValue = (date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// const parseDateValue = (value) => {
//   if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value || ''))) return null;
//   const [year, month, day] = String(value).split('-').map(Number);
//   const candidate = new Date(year, month - 1, day);
//   return Number.isNaN(candidate.getTime())
//     || candidate.getFullYear() !== year
//     || candidate.getMonth() !== month - 1
//     || candidate.getDate() !== day
//     ? null
//     : candidate;
// };

// const normalizeDateValidation = (value = {}) => {
//   const normalizeLimit = (limit) => (
//     limit !== null
//     && limit !== undefined
//     && limit !== ''
//     && Number.isInteger(Number(limit))
//     && Number(limit) >= 0
//       ? Number(limit)
//       : null
//   );

//   return {
//     allowToday: value?.allowToday !== false,
//     allowPast: value?.allowPast !== false,
//     allowFuture: value?.allowFuture !== false,
//     maxPastDays: normalizeLimit(value?.maxPastDays),
//     maxFutureDays: normalizeLimit(value?.maxFutureDays),
//   };
// };

// const getLocalDayNumber = (date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;

// const isDateAllowed = (date, validation) => {
//   const rules = normalizeDateValidation(validation);
//   const dayDifference = getLocalDayNumber(date) - getLocalDayNumber(new Date());
//   if (dayDifference === 0) return rules.allowToday;
//   if (dayDifference < 0) {
//     return rules.allowPast && (rules.maxPastDays === null || Math.abs(dayDifference) <= rules.maxPastDays);
//   }
//   return rules.allowFuture && (rules.maxFutureDays === null || dayDifference <= rules.maxFutureDays);
// };

// const PreviewDateCalendar = ({ month, value, onMonthChange, onSelect, validation, themeMode, primaryColor }) => {
//   const year = month.getFullYear();
//   const monthIndex = month.getMonth();
//   const firstWeekday = new Date(year, monthIndex, 1).getDay();
//   const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
//   const selectedValue = String(value || '');
//   const todayValue = toLocalDateValue(new Date());
//   const cells = Array.from({ length: firstWeekday + daysInMonth }, (_, index) => (
//     index < firstWeekday ? null : new Date(year, monthIndex, index - firstWeekday + 1)
//   ));
//   const dark = themeMode === 'dark';

//   return (
//     <div
//       className="mb-3 rounded-2xl border p-3 shadow-xl"
//       style={{
//         borderColor: dark ? 'rgba(148,163,184,0.24)' : '#dbe4f0',
//         background: dark ? '#111827' : '#ffffff',
//       }}
//     >
//       <div className="mb-3 flex items-center justify-between gap-3">
//         <button
//           type="button"
//           onClick={() => onMonthChange(new Date(year, monthIndex - 1, 1))}
//           className="h-8 w-8 rounded-lg text-sm font-semibold transition hover:bg-slate-100 dark:hover:bg-white/10"
//           style={{ color: dark ? '#e2e8f0' : '#334155' }}
//           aria-label="Previous month"
//         >
//           ‹
//         </button>
//         <div className="text-sm font-semibold" style={{ color: dark ? '#f8fafc' : '#0f172a' }}>
//           {month.toLocaleDateString(undefined, { month: 'long', year: 'numeric' })}
//         </div>
//         <button
//           type="button"
//           onClick={() => onMonthChange(new Date(year, monthIndex + 1, 1))}
//           className="h-8 w-8 rounded-lg text-sm font-semibold transition hover:bg-slate-100 dark:hover:bg-white/10"
//           style={{ color: dark ? '#e2e8f0' : '#334155' }}
//           aria-label="Next month"
//         >
//           ›
//         </button>
//       </div>
//       <div className="grid grid-cols-7 gap-1 text-center text-[10px] font-medium uppercase tracking-wide" style={{ color: dark ? '#94a3b8' : '#64748b' }}>
//         {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => <div key={day} className="py-1">{day}</div>)}
//       </div>
//       <div className="grid grid-cols-7 gap-1">
//         {cells.map((date, index) => {
//           if (!date) return <div key={`empty-${index}`} />;
//           const dateValue = toLocalDateValue(date);
//           const selected = dateValue === selectedValue;
//           const today = dateValue === todayValue;
//           const allowed = isDateAllowed(date, validation);
//           return (
//             <button
//               key={dateValue}
//               type="button"
//               disabled={!allowed}
//               onClick={() => allowed && onSelect(dateValue)}
//               className="h-8 rounded-lg text-xs font-medium transition disabled:cursor-not-allowed"
//               title={allowed ? `Select ${dateValue}` : 'This date is not allowed by the node validation rules'}
//               style={selected
//                 ? { background: primaryColor, color: '#ffffff' }
//                 : {
//                     color: allowed ? (dark ? '#e2e8f0' : '#334155') : (dark ? '#475569' : '#cbd5e1'),
//                     background: allowed ? 'transparent' : (dark ? 'rgba(15,23,42,0.55)' : '#f8fafc'),
//                     boxShadow: today ? `inset 0 0 0 1px ${primaryColor}` : 'none',
//                   }}
//             >
//               {date.getDate()}
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default function ChatPreview({
//   title = 'Chat Preview',
//   subtitle = 'Live bot testing',
//   botName = 'Lucky',
//   status = 'Online',
//   avatarText = 'VB',
//   avatarUrl = '',
//   showHeader = true,
//   showAvatar = true,
//   showTitle = true,
//   showSubtitle = true,
//   showStatus = true,
//   showReset = true,
//   resetLabel = 'Reset',
//   messages = [],
//   typing = false,
//   quickReplies = [],
//   inputValue = '',
//   onInputChange = () => {},
//   onSend = () => {},
//   onQuickReply = () => {},
//   onReset = () => {},
//   onHome = () => {},
//   onClose = null,
//   inputType = 'text',
//   dateValidation = {},
//   placeholder = 'Type a message...',
//   footerHint = 'Responses appear with a short simulated delay.',
//   themeMode = 'light',
//   primaryColor = '#d95b0a',
//   accentColor = '#f26a00',
//   complementaryColor = '#15588a',
//   fontFamily = 'inherit',
//   fontSize = 'medium',
//   textSize = 14,
//   textColor = '',
// }) {
//   const scrollRef = useRef(null);
//   const inputRef = useRef(null);
//   const previousInputTypeRef = useRef(inputType);
//   const [datePickerOpen, setDatePickerOpen] = useState(inputType === 'date');
//   const [calendarMonth, setCalendarMonth] = useState(() => parseDateValue(inputValue) || new Date());

//   useEffect(() => {
//     const el = scrollRef.current;
//     if (!el) return;

//     requestAnimationFrame(() => {
//       el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
//     });
//   }, [messages, typing]);

//   // Native date dialogs are user-gesture restricted after an async bot reply.
//   // Keep a first-class calendar open instead so Date nodes always work without
//   // requiring the user to tap the field a second time.
//   useEffect(() => {
//     const changedToDate = inputType === 'date' && previousInputTypeRef.current !== 'date';
//     previousInputTypeRef.current = inputType;
//     if (inputType !== 'date') {
//       setDatePickerOpen(false);
//       return undefined;
//     }

//     setDatePickerOpen(true);
//     const parsedValue = parseDateValue(inputValue);
//     if (parsedValue) setCalendarMonth(parsedValue);
//     if (changedToDate) {
//       window.setTimeout(() => inputRef.current?.focus(), 0);
//     }
//     return undefined;
//   }, [inputType]);

//   const renderedMessages = useMemo(
//     () =>
//       messages.map((message, index) => ({
//         ...message,
//         key: message.id || `${message.role}-${index}-${message.text}`,
//         startsGroup: index === 0 || messages[index - 1]?.role !== message.role,
//         endsGroup: index === messages.length - 1 || messages[index + 1]?.role !== message.role,
//       })),
//     [messages]
//   );

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     onSend();
//   };

//   const previewScaleClass = fontSize === 'small' ? 'text-[0.92rem]' : fontSize === 'large' ? 'text-[1.05rem]' : 'text-base';
//   const shellBg = themeMode === 'dark' ? '#0b1120' : '#f6f7fb';
//   const chatBg = themeMode === 'dark' ? '#111827' : '#f8f8fb';
//   const panelBg = themeMode === 'dark' ? '#0f172a' : '#ffffff';
//   const panelBorder = themeMode === 'dark' ? 'rgba(148,163,184,0.2)' : 'rgba(203,213,225,0.7)';
//   const subtleText = themeMode === 'dark' ? '#94a3b8' : '#64748b';
//   const dateBg = themeMode === 'dark' ? 'rgba(255,255,255,0.08)' : '#efe7df';
//   const resolvedTextSize = Math.min(22, Math.max(12, Number(textSize) || 14));
//   const resolvedTextColor = textColor || (themeMode === 'dark' ? '#e5e7eb' : '#0f172a');

//   return (
//     <div
//       className={`flex h-full min-h-0 flex-col overflow-hidden rounded-[24px] shadow-2xl shadow-slate-900/20 ${previewScaleClass}`}
//       style={{ border: `1px solid ${panelBorder}`, background: shellBg, color: resolvedTextColor, fontFamily }}
//     >
//       {showHeader ? (
//         <div
//           className="border-b px-4 py-3.5 text-white"
//           style={{ borderColor: 'rgba(0,0,0,0.06)', background: `linear-gradient(90deg, ${primaryColor} 0%, ${accentColor} 100%)` }}
//         >
//           <div className="flex items-center justify-between gap-3">
//             <div className="flex min-w-0 items-center gap-3">
//               {showAvatar ? (
//                 <motion.div
//                   className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white/70 bg-white text-sm font-semibold shadow-lg"
//                   style={{ color: primaryColor }}
//                   animate={typing ? { scale: [1, 1.04, 1] } : { scale: 1 }}
//                   transition={{ duration: 1.2, repeat: typing ? Infinity : 0 }}
//                 >
//                   {avatarUrl ? <img src={avatarUrl} alt="" className="h-full w-full object-cover" /> : avatarText}
//                 </motion.div>
//               ) : null}
//               <div className="min-w-0">
//                 {showTitle ? <div className="truncate font-semibold text-white" style={{ fontSize: `${resolvedTextSize + 2}px` }}>{title}</div> : null}
//                 {showSubtitle ? <div className="truncate text-orange-100/90" style={{ fontSize: `${Math.max(11, resolvedTextSize - 2)}px` }}>{subtitle}</div> : null}
//                 {showStatus ? (
//                   <div className="mt-1 flex items-center gap-2 text-orange-100/80" style={{ fontSize: `${Math.max(10, resolvedTextSize - 3)}px` }}>
//                     <span className="h-2 w-2 rounded-full" style={{ background: complementaryColor }} />
//                     <span>{botName}</span>
//                     <span>•</span>
//                     <span>{status}</span>
//                   </div>
//                 ) : null}
//               </div>
//             </div>

//             <div className="flex items-center gap-2">
//               {showReset ? (
//                 <button
//                   type="button"
//                   onClick={onReset}
//                   className="inline-flex items-center gap-2 rounded-2xl border border-white/20 bg-white/10 px-3 py-2 text-xs font-medium text-white transition hover:bg-white/15"
//                 >
//                   <ResetGlyph />
//                   {resetLabel}
//                 </button>
//               ) : null}
//               {onClose ? (
//                 <button
//                   type="button"
//                   onClick={onClose}
//                   className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white/90 transition hover:bg-white/15 hover:text-white"
//                   aria-label="Close bot preview"
//                   title="Close"
//                 >
//                   <CloseGlyph />
//                 </button>
//               ) : null}
//             </div>
//           </div>
//         </div>
//       ) : null}

//       <div
//         ref={scrollRef}
//         className="flex-1 min-h-0 space-y-4 overflow-y-auto px-4 py-4"
//         style={{ background: chatBg }}
//       >
//         <div className="flex justify-center">
//           <div className="rounded-full px-4 py-1 text-[12px] font-medium" style={{ background: dateBg, color: subtleText }}>
//             Today
//           </div>
//         </div>
//         <AnimatePresence initial={false}>
//           {renderedMessages.map((message, index) => (
//             <motion.div
//               key={message.key}
//               initial={{ opacity: 0, y: 12, scale: 0.98 }}
//               animate={{ opacity: 1, y: 0, scale: 1 }}
//               transition={{
//                 duration: 0.22,
//                 delay: Math.min(index * 0.04, 0.25),
//                 ease: 'easeOut',
//               }}
//             >
//               {message.role === 'user' ? (
//                 <Bubble role="user" primaryColor={primaryColor} accentColor={accentColor} themeMode={themeMode} textSize={resolvedTextSize} textColor={resolvedTextColor}>
//                   <div className="mt-1 whitespace-pre-wrap break-words [overflow-wrap:anywhere]">{message.text}</div>
//                 </Bubble>
//               ) : (
//                 <div className="flex min-w-0 w-full items-end gap-3">
//                   {message.startsGroup ? (
//                     <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-[11px] font-semibold text-[#b43b00] shadow-sm">
//                       {avatarText}
//                     </div>
//                   ) : (
//                     <div className="h-9 w-9 shrink-0" />
//                   )}
//                   <Bubble
//                     role="bot"
//                     wide={Boolean(message.mediaUrl)}
//                     primaryColor={primaryColor}
//                     accentColor={accentColor}
//                     themeMode={themeMode}
//                     textSize={resolvedTextSize}
//                     textColor={resolvedTextColor}
//                   >
//                     <MediaContent message={message} themeMode={themeMode} />
//                     {message.text ? <div className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">{message.text}</div> : null}
//                   </Bubble>
//                 </div>
//               )}
//             </motion.div>
//           ))}
//         </AnimatePresence>

//         {typing && (
//           <motion.div
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.18 }}
//             className="flex items-end gap-3"
//           >
//             <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-[11px] font-semibold shadow-sm" style={{ border: `1px solid ${panelBorder}`, color: primaryColor }}>
//               {avatarText}
//             </div>
//             <div className="rounded-[24px] rounded-bl-[8px] px-4 py-3 shadow-sm" style={{ border: `1px solid ${panelBorder}`, background: panelBg, color: resolvedTextColor }}>
//               <TypingDots />
//             </div>
//           </motion.div>
//         )}

//         {quickReplies?.length > 0 && (
//           <div className="space-y-2 pl-12">
//             {quickReplies.map((reply) => (
//               <motion.button
//                 key={reply}
//                 type="button"
//                 whileHover={{ y: -1 }}
//                 whileTap={{ scale: 0.98 }}
//                 onClick={() => onQuickReply(reply)}
//                 className="flex min-w-0 w-full items-center justify-center whitespace-normal break-words rounded-[14px] px-4 py-2.5 text-center text-sm font-semibold shadow-sm transition [overflow-wrap:anywhere]"
//                 style={{ border: `1px solid ${panelBorder}`, background: panelBg, color: resolvedTextColor, fontSize: `${resolvedTextSize}px` }}
//               >
//                 {reply}
//               </motion.button>
//             ))}
//           </div>
//         )}
//       </div>

//       <div className="border-t px-4 py-3" style={{ borderColor: panelBorder, background: panelBg }}>
//         {inputType === 'date' && datePickerOpen ? (
//           <PreviewDateCalendar
//             month={calendarMonth}
//             value={inputValue}
//             validation={dateValidation}
//             onMonthChange={setCalendarMonth}
//             onSelect={(dateValue) => {
//               onInputChange(dateValue);
//               setDatePickerOpen(false);
//               onSend(dateValue);
//             }}
//             themeMode={themeMode}
//             primaryColor={primaryColor}
//           />
//         ) : null}

//         <form onSubmit={handleSubmit} className="flex items-center gap-3">
//           <motion.button
//             type="button"
//             whileHover={{ scale: 1.03 }}
//             whileTap={{ scale: 0.97 }}
//             onClick={onHome}
//             className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full shadow-sm transition"
//             style={{ border: `1px solid ${panelBorder}`, background: themeMode === 'dark' ? '#111827' : '#f8fafc', color: subtleText }}
//             title="Open default journey"
//           >
//             <HomeGlyph />
//           </motion.button>
//           <div className="flex min-w-0 flex-1 items-center gap-2 rounded-full px-3 py-0.5 shadow-sm" style={{ border: `1px solid ${panelBorder}`, background: panelBg }}>
//             <input
//               ref={inputRef}
//               type={inputType}
//               value={inputValue}
//               onChange={(event) => onInputChange(event.target.value)}
//               onClick={() => {
//                 if (inputType === 'date') setDatePickerOpen(true);
//               }}
//               placeholder={placeholder}
//               className="min-w-0 flex-1 rounded-full bg-transparent px-1 py-2.5 text-sm outline-none"
//               style={{ color: resolvedTextColor, fontSize: `${resolvedTextSize}px` }}
//             />
//             {inputType === 'date' ? null : (
//               <button
//                 type="button"
//                 className="inline-flex h-9 w-9 items-center justify-center rounded-full transition"
//                 style={{ color: subtleText }}
//                 title="Attachment"
//               >
//                 <AttachGlyph />
//               </button>
//             )}
//           </div>
//           <motion.button
//             type="submit"
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             className="inline-flex h-11 min-w-[88px] items-center justify-center rounded-full px-5 text-sm font-semibold text-white shadow-lg transition"
//             style={{ background: `linear-gradient(90deg, ${primaryColor} 0%, ${accentColor} 100%)`, boxShadow: `0 12px 24px ${primaryColor}33`, fontSize: `${resolvedTextSize}px` }}
//           >
//             Send
//           </motion.button>
//         </form>

//         {footerHint ? (
//           <div className="mt-3 break-words text-[11px] leading-5 [overflow-wrap:anywhere]" style={{ color: subtleText }}>{footerHint}</div>
//         ) : null}
//       </div>
//     </div>
//   );
// }


import BotMessageText from '../utils/BotMessageText';
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import {
  AnimatePresence,
  motion,
} from 'framer-motion';

/** Purpose: Resolve absolute, inline, and API-relative avatar URLs. Why: Preview assets may be served from a different origin. */
const resolveAvatarUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (url.startsWith('/')) {
    const envBase = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL)
      ? process.env.REACT_APP_API_URL.replace(/\/+$/, '')
      : '';
    return envBase ? `${envBase}${url}` : url;
  }
  return url;
};


// ======================================================
// ICONS
// ======================================================

/** Purpose: Resolve home glyph in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const HomeGlyph = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V21h14V9.5" />
    <path d="M9 21v-6h6v6" />
  </svg>
);


/** Purpose: Render the chat-reset icon. Why: The header needs a recognizable reset control without an image request. */
const ResetGlyph = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 12a9 9 0 1 0 3-6.7" />
    <path d="M3 4v5h5" />
  </svg>
);


/** Purpose: Render the attachment icon. Why: The composer identifies file selection with a consistent SVG. */
const AttachGlyph = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m21.44 11.05-8.49 8.49a6 6 0 0 1-8.49-8.49l9.19-9.2a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 1 1-2.82-2.83l8.49-8.48" />
  </svg>
);


/** Purpose: Render the close icon. Why: The preview needs a compact dismissal control. */
const CloseGlyph = () => (
  <svg
    viewBox="0 0 24 24"
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="m6 6 12 12" />
    <path d="M18 6 6 18" />
  </svg>
);


// ======================================================
// MESSAGE BUBBLE
// ======================================================

/** Purpose: Resolve bubble in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const Bubble = ({
  role,
  children,
  wide = false,
  primaryColor = '#d95b0a',
  accentColor = '#f26a00',
  themeMode = 'light',
  textSize = 14,
  textColor = '',
}) => {
  const isUser =
    role === 'user';

  const botBg =
    themeMode === 'dark'
      ? '#0f172a'
      : '#ffffff';

  const botBorder =
    themeMode === 'dark'
      ? 'rgba(148,163,184,0.24)'
      : '#e2e8f0';

  const botText =
    textColor ||
    (
      themeMode === 'dark'
        ? '#e5e7eb'
        : '#1e293b'
    );

  return (
    <div
      className={`flex min-w-0 w-full ${
        isUser
          ? 'justify-end'
          : 'justify-start'
      }`}
    >
      <div
        className={[
          'min-w-0',
          'max-w-[82%]',
          'overflow-hidden',
          'break-words',
          'rounded-[24px]',
          'px-4',
          'py-3',
          'text-sm',
          'leading-6',
          'shadow-lg',
          'backdrop-blur-sm',
          '[overflow-wrap:anywhere]',

          wide
            ? 'w-full'
            : '',

          isUser
            ? 'rounded-br-[8px] text-white shadow-orange-400/20'
            : 'rounded-bl-[8px]',
        ].join(' ')}
        style={
          isUser
            ? {
                background:
                  `linear-gradient(135deg, ${primaryColor} 0%, ${accentColor} 100%)`,

                fontSize:
                  `${textSize}px`,
              }
            : {
                background:
                  botBg,

                border:
                  `1px solid ${botBorder}`,

                color:
                  botText,

                fontSize:
                  `${textSize}px`,
              }
        }
      >
        {children}
      </div>
    </div>
  );
};


// ======================================================
// TYPING INDICATOR
// ======================================================

/** Purpose: Transform typing dots in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const TypingDots = () => (
  <div className="flex items-center gap-1.5 py-1">
    {[0, 1, 2].map(
      (index) => (
        <motion.span
          key={index}
          className="h-2.5 w-2.5 rounded-full bg-emerald-300/90"
          animate={{
            y: [
              0,
              -3,
              0,
            ],

            opacity: [
              0.35,
              1,
              0.35,
            ],
          }}
          transition={{
            duration: 0.9,

            repeat:
              Infinity,

            ease:
              'easeInOut',

            delay:
              index * 0.14,
          }}
        />
      )
    )}
  </div>
);


// ======================================================
// MEDIA RENDERER
// ======================================================

/** Purpose: Resolve media content in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const MediaContent = ({
  message,
  themeMode,
}) => {
  const mediaUrl =
    String(
      message?.mediaUrl ||
      ''
    ).trim();

  if (!mediaUrl) {
    return null;
  }

  const mediaType =
    String(
      message?.mediaType ||
      message?.type ||
      'image'
    ).toLowerCase();

  const label =
    message?.alt ||
    message?.text ||
    'Bot attachment';


  // ----------------------------------------------------
  // VIDEO
  // ----------------------------------------------------

  if (
    mediaType === 'video'
  ) {
    return (
      <video
        controls
        preload="metadata"
        className="mb-2 max-h-64 w-full rounded-2xl bg-black object-contain"
      >
        <source
          src={mediaUrl}
        />

        Your browser cannot play this video.
      </video>
    );
  }


  // ----------------------------------------------------
  // FILE
  // ----------------------------------------------------

  if (
    mediaType === 'file'
  ) {
    return (
      <a
        href={mediaUrl}
        target="_blank"
        rel="noreferrer"
        className="mb-2 block rounded-xl border px-3 py-2 text-sm font-semibold underline"
        style={{
          borderColor:
            themeMode === 'dark'
              ? 'rgba(148,163,184,0.3)'
              : '#dbe4f0',
        }}
      >
        {
          label ||
          'Open attachment'
        }
      </a>
    );
  }


  // ----------------------------------------------------
  // IMAGE
  // ----------------------------------------------------

  return (
    <img
      src={mediaUrl}
      alt={label}
      loading="eager"
      className="mb-2 max-h-72 w-full rounded-2xl object-cover"
    />
  );
};


// ======================================================
// DATE HELPERS
// ======================================================

/** Purpose: Resolve to local date value in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const toLocalDateValue = (
  date
) => {
  const year =
    date.getFullYear();

  const month =
    String(
      date.getMonth() + 1
    ).padStart(
      2,
      '0'
    );

  const day =
    String(
      date.getDate()
    ).padStart(
      2,
      '0'
    );

  return `${day}/${month}/${year}`;
};


/** Purpose: Parse supported ISO or display dates into a validated date. Why: Malformed dates must not silently roll into another month. */
const parseDateValue = (
  value
) => {
  const normalized =
    String(
      value ||
      ''
    );

  const isoMatch = normalized.match(
    /^(\d{4})-(\d{2})-(\d{2})$/
  );

  const displayMatch = normalized.match(
    /^(\d{2})\/(\d{2})\/(\d{4})$/
  );

  if (!isoMatch && !displayMatch) {
    return null;
  }

  const year = Number(isoMatch ? isoMatch[1] : displayMatch[3]);
  const month = Number(isoMatch ? isoMatch[2] : displayMatch[2]);
  const day = Number(isoMatch ? isoMatch[3] : displayMatch[1]);

  const candidate =
    new Date(
      year,
      month - 1,
      day
    );

  if (
    Number.isNaN(
      candidate.getTime()
    )
  ) {
    return null;
  }

  if (
    candidate.getFullYear() !==
      year ||
    candidate.getMonth() !==
      month - 1 ||
    candidate.getDate() !==
      day
  ) {
    return null;
  }

  return candidate;
};


/** Purpose: Normalize date-selection permissions and optional day limits. Why: Saved and partially edited rules need consistent calendar behavior. */
const normalizeDateValidation = (
  value = {}
) => {
  /** Purpose: Accept nonnegative whole-day bounds or return no bound. Why: Invalid form values must not accidentally constrain selection. */
  const normalizeLimit = (
    limit
  ) => {
    if (
      limit === null ||
      limit === undefined ||
      limit === ''
    ) {
      return null;
    }

    const numeric =
      Number(
        limit
      );

    if (
      !Number.isInteger(
        numeric
      ) ||
      numeric < 0
    ) {
      return null;
    }

    return numeric;
  };


  return {
    allowToday:
      value?.allowToday !==
      false,

    allowPast:
      value?.allowPast !==
      false,

    allowFuture:
      value?.allowFuture !==
      false,

    maxPastDays:
      normalizeLimit(
        value?.maxPastDays
      ),

    maxFutureDays:
      normalizeLimit(
        value?.maxFutureDays
      ),
  };
};


/** Purpose: Convert local calendar components to a comparable day index. Why: Comparisons must ignore time-of-day and daylight-saving hour changes. */
const getLocalDayNumber = (
  date
) =>
  Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ) /
  86400000;


/** Purpose: Check dates against past, today, future, and day-limit rules. Why: Calendar availability must agree with prompt validation. */
const isDateAllowed = (
  date,
  validation
) => {
  const rules =
    normalizeDateValidation(
      validation
    );

  const dayDifference =
    getLocalDayNumber(
      date
    ) -
    getLocalDayNumber(
      new Date()
    );


  // TODAY
  if (
    dayDifference === 0
  ) {
    return rules.allowToday;
  }


  // PAST
  if (
    dayDifference < 0
  ) {
    return (
      rules.allowPast &&
      (
        rules.maxPastDays ===
          null ||
        Math.abs(
          dayDifference
        ) <=
          rules.maxPastDays
      )
    );
  }


  // FUTURE
  return (
    rules.allowFuture &&
    (
      rules.maxFutureDays ===
        null ||
      dayDifference <=
        rules.maxFutureDays
    )
  );
};


// ======================================================
// DATE CALENDAR
// ======================================================

/** Purpose: Transform preview date calendar in the chat preview module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
const PreviewDateCalendar = ({
  month,
  value,
  onMonthChange,
  onSelect,
  validation,
  themeMode,
  primaryColor,
}) => {
  const year =
    month.getFullYear();

  const monthIndex =
    month.getMonth();

  const firstWeekday =
    new Date(
      year,
      monthIndex,
      1
    ).getDay();

  const daysInMonth =
    new Date(
      year,
      monthIndex + 1,
      0
    ).getDate();

  const selectedValue =
    String(
      value ||
      ''
    );

  const todayValue =
    toLocalDateValue(
      new Date()
    );

  /** Purpose: Build calendar cells with leading weekday blanks. Why: Dates must align beneath the correct weekday headings. */
  const cells =
    Array.from(
      {
        length:
          firstWeekday +
          daysInMonth,
      },

      (
        _,
        index
      ) => {
        if (
          index <
          firstWeekday
        ) {
          return null;
        }

        return new Date(
          year,
          monthIndex,
          index -
            firstWeekday +
            1
        );
      }
    );


  const dark =
    themeMode === 'dark';


  return (
    <div
      className="mx-auto mb-3 w-[90%] rounded-2xl border p-2.5 shadow-xl"
      style={{
        borderColor:
          dark
            ? 'rgba(148,163,184,0.24)'
            : '#dbe4f0',

        background:
          dark
            ? '#111827'
            : '#ffffff',
      }}
    >

      {/* HEADER */}

      <div className="mb-2.5 flex items-center justify-between gap-2.5">

        <button
          type="button"
          onClick={() =>
            onMonthChange(
              new Date(
                year,
                monthIndex - 1,
                1
              )
            )
          }
          className="h-7 w-7 rounded-lg text-sm font-semibold transition hover:bg-slate-100 dark:hover:bg-white/10"
          style={{
            color:
              dark
                ? '#e2e8f0'
                : '#334155',
          }}
          aria-label="Previous month"
        >
          ‹
        </button>


        <div
          className="text-sm font-semibold"
          style={{
            color:
              dark
                ? '#f8fafc'
                : '#0f172a',
          }}
        >
          {
            month.toLocaleDateString(
              undefined,
              {
                month:
                  'long',

                year:
                  'numeric',
              }
            )
          }
        </div>


        <button
          type="button"
          onClick={() =>
            onMonthChange(
              new Date(
                year,
                monthIndex + 1,
                1
              )
            )
          }
          className="h-7 w-7 rounded-lg text-sm font-semibold transition hover:bg-slate-100 dark:hover:bg-white/10"
          style={{
            color:
              dark
                ? '#e2e8f0'
                : '#334155',
          }}
          aria-label="Next month"
        >
          ›
        </button>

      </div>


      {/* DAYS */}

      <div
        className="grid grid-cols-7 gap-1 text-center text-[10px] font-medium uppercase tracking-wide"
        style={{
          color:
            dark
              ? '#94a3b8'
              : '#64748b',
        }}
      >
        {[
          'Sun',
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
          'Sat',
        ].map(
          (day) => (
            <div
              key={day}
              className="py-1"
            >
              {day}
            </div>
          )
        )}
      </div>


      {/* DATE CELLS */}

      <div className="grid grid-cols-7 gap-1">

        {cells.map(
          (
            date,
            index
          ) => {

            if (!date) {
              return (
                <div
                  key={`empty-${index}`}
                />
              );
            }


            const dateValue =
              toLocalDateValue(
                date
              );


            const selected =
              dateValue ===
              selectedValue;


            const today =
              dateValue ===
              todayValue;


            const allowed =
              isDateAllowed(
                date,
                validation
              );


            return (
              <button
                key={dateValue}
                type="button"
                disabled={!allowed}
                onClick={() => {
                  if (
                    allowed
                  ) {
                    onSelect(
                      dateValue
                    );
                  }
                }}
                className="h-7 rounded-lg text-[11px] font-medium transition disabled:cursor-not-allowed"
                title={
                  allowed
                    ? `Select ${dateValue}`
                    : 'This date is not allowed by the node validation rules'
                }
                style={
                  selected
                    ? {
                        background:
                          primaryColor,

                        color:
                          '#ffffff',
                      }
                    : {
                        color:
                          allowed
                            ? (
                                dark
                                  ? '#e2e8f0'
                                  : '#334155'
                              )
                            : (
                                dark
                                  ? '#475569'
                                  : '#cbd5e1'
                              ),

                        background:
                          allowed
                            ? 'transparent'
                            : (
                                dark
                                  ? 'rgba(15,23,42,0.55)'
                                  : '#f8fafc'
                              ),

                        boxShadow:
                          today
                            ? `inset 0 0 0 1px ${primaryColor}`
                            : 'none',
                      }
                }
              >
                {
                  date.getDate()
                }
              </button>
            );
          }
        )}

      </div>

    </div>
  );
};


// ======================================================
// CHAT PREVIEW
//
// IMPORTANT:
// This component stays UI-only.
//
// Dashboard Preview and Live Widget can both reuse this.
// Flow/API/session logic stays outside this component.
// ======================================================

/** Purpose: render the configurable chat widget preview. Why: settings changes should be testable in context before they are saved or published. */
export default function ChatPreview({
  title = 'Chat Preview',
  subtitle = 'Live bot testing',

  botName = 'Lucky',
  status = 'Online',
  agentIdentity = '',

  avatarText = 'VB',
  avatarUrl = '',

  showHeader = true,
  showAvatar = true,
  showTitle = true,
  showSubtitle = true,
  showStatus = true,
  showReset = true,
  showHome = true,
  showWatermark = true,
  watermarkUrl = 'https://zelorich.com',

  resetLabel = 'Reset',

  messages = [],

  typing = false,

  quickReplies = [],

  inputValue = '',

  onInputChange = () => {},

  onSend = () => {},

  onQuickReply = () => {},

  // Most settings previews only need the displayed value. Flow previews opt
  // into the full object so routing payloads are not lost on click.
  preserveQuickReplyPayload = false,

  onReset = () => {},

  onHome = () => {},

  onAttachment = null,

  onClose = null,

  inputType = 'text',

  dateValidation = {},

  placeholder =
    'Type a message...',

  footerHint =
    'Responses appear with a short simulated delay.',

  themeMode = 'light',

  primaryColor =
    '#d95b0a',

  accentColor =
    '#f26a00',

  complementaryColor =
    '#15588a',

  fontFamily =
    'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',

  fontSize =
    'medium',

  textSize =
    14,

  textColor =
    '',
}) {

  // ====================================================
  // REFS
  // ====================================================

  const scrollRef =
    useRef(
      null
    );


  const inputRef =
    useRef(
      null
    );

  const attachmentInputRef = useRef(null);


  const previousInputTypeRef =
    useRef(
      inputType
    );


  // ====================================================
  // DATE STATE
  // ====================================================

  const [
    datePickerOpen,
    setDatePickerOpen,
  ] =
    useState(
      inputType ===
      'date'
    );


  const [
    calendarMonth,
    setCalendarMonth,
  ] =
    useState(
      () =>
        parseDateValue(
          inputValue
        ) ||
        new Date()
    );


  // ====================================================
  // AUTO SCROLL
  // ====================================================

  useEffect(
    () => {
      const element =
        scrollRef.current;

      if (
        !element
      ) {
        return;
      }


      /** Purpose: Scroll the container to its newest message. Why: New replies should remain visible during preview. */
      const scrollToLatest =
        () => {
          element.scrollTop =
            element.scrollHeight;
        };

      // Opening the calendar changes the remaining message-area height.
      // Wait for that layout change before pinning the latest message above it.
      requestAnimationFrame(
        () => {
          scrollToLatest();
          requestAnimationFrame(
            scrollToLatest
          );
        }
      );

    },
    [
      messages,
      typing,
      quickReplies,
      datePickerOpen,
      inputType,
    ]
  );


  // ====================================================
  // DATE INPUT TYPE CHANGE
  // ====================================================

  useEffect(
    () => {

      const changedToDate =
        inputType === 'date' &&
        previousInputTypeRef.current !==
          'date';


      previousInputTypeRef.current =
        inputType;


      if (
        inputType !==
        'date'
      ) {
        setDatePickerOpen(
          false
        );

        return undefined;
      }


      // Date node → automatically show calendar
      setDatePickerOpen(
        true
      );


      const parsedValue =
        parseDateValue(
          inputValue
        );


      if (
        parsedValue
      ) {
        setCalendarMonth(
          parsedValue
        );
      }


      if (
        changedToDate
      ) {
        window.setTimeout(
          () => {
            inputRef.current?.focus();
          },
          0
        );
      }


      return undefined;

    },
    [
      inputType,
      inputValue,
    ]
  );


  // ====================================================
  // NORMALIZE MESSAGES
  // ====================================================

  /** Purpose: Provide the rendered messages operation for the chat preview module. Why: Callers depend on this shared result to keep the surrounding flow consistent. */
  const renderedMessages =
    useMemo(
      () =>
        messages.map(
          (
            message,
            index
          ) => ({
            ...message,

            key:
              message.id ||
              `${message.role}-${index}-${message.text}`,

            startsGroup:
              index === 0 ||
              messages[
                index - 1
              ]?.role !==
                message.role,

            endsGroup:
              index ===
                messages.length -
                  1 ||
              messages[
                index + 1
              ]?.role !==
                message.role,
          })
        ),

      [
        messages,
      ]
    );


  // ====================================================
  // SEND
  // ====================================================

  /** Purpose: Handle handle submit in the chat preview module. Why: This keeps the corresponding action and its state or request update consistent. */
  const handleSubmit = (
    event
  ) => {
    event.preventDefault();

    onSend();
  };


  // ====================================================
  // THEME
  // ====================================================

  const previewScaleClass =
    fontSize === 'small'
      ? 'text-[0.92rem]'
      : fontSize ===
          'large'
        ? 'text-[1.05rem]'
        : 'text-base';


  const shellBg =
    themeMode === 'dark'
      ? '#0b1120'
      : '#f6f7fb';


  const chatBg =
    themeMode === 'dark'
      ? '#111827'
      : '#f8f8fb';


  const panelBg =
    themeMode === 'dark'
      ? '#0f172a'
      : '#ffffff';


  const panelBorder =
    themeMode === 'dark'
      ? 'rgba(148,163,184,0.2)'
      : 'rgba(203,213,225,0.7)';


  const subtleText =
    themeMode === 'dark'
      ? '#94a3b8'
      : '#64748b';


  const dateBg =
    themeMode === 'dark'
      ? 'rgba(255,255,255,0.08)'
      : '#efe7df';


  const resolvedTextSize =
    Math.min(
      22,
      Math.max(
        12,
        Number(
          textSize
        ) ||
        14
      )
    );


  const resolvedTextColor =
    textColor ||
    (
      themeMode === 'dark'
        ? '#e5e7eb'
        : '#0f172a'
    );


  // ====================================================
  // RENDER
  // ====================================================

  return (
    <div
      className={`flex h-full min-h-0 flex-col overflow-hidden rounded-[24px] shadow-2xl shadow-slate-900/20 ${previewScaleClass}`}
      style={{
        border:
          `1px solid ${panelBorder}`,

        background:
          shellBg,

        color:
          resolvedTextColor,

        fontFamily,
      }}
    >

      {/* =================================================
          HEADER
      ================================================= */}

      {showHeader ? (
        <div
          className="border-b px-4 py-3.5 text-white"
          style={{
            borderColor:
              'rgba(0,0,0,0.06)',

            background:
              `linear-gradient(90deg, ${primaryColor} 0%, ${accentColor} 100%)`,
          }}
        >

          <div className="flex items-center justify-between gap-3">

            <div className="flex min-w-0 items-center gap-3">

              {showAvatar ? (
                <motion.div
                  className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white/70 bg-white text-sm font-semibold shadow-lg"
                  style={{
                    color:
                      primaryColor,
                  }}
                  animate={
                    typing
                      ? {
                          scale: [
                            1,
                            1.04,
                            1,
                          ],
                        }
                      : {
                          scale:
                            1,
                        }
                  }
                  transition={{
                    duration:
                      1.2,

                    repeat:
                      typing
                        ? Infinity
                        : 0,
                  }}
                >
                  {avatarUrl ? (
                    <img
                      src={resolveAvatarUrl(avatarUrl)}
                      alt=""
                      className="h-full w-full object-cover"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        if (e.currentTarget.nextSibling) {
                          e.currentTarget.nextSibling.style.display = 'inline';
                        }
                      }}
                    />
                  ) : null}
                  <span style={{ display: avatarUrl ? 'none' : 'inline' }}>
                    {avatarText}
                  </span>
                </motion.div>
              ) : null}


              <div className="min-w-0">

                {showTitle ? (
                  <div
                    className="truncate font-semibold text-white"
                    style={{
                      fontSize:
                        `${resolvedTextSize + 2}px`,
                    }}
                  >
                    {title}
                  </div>
                ) : null}


                {showSubtitle ? (
                  <div
                    className="truncate text-orange-100/90"
                    style={{
                      fontSize:
                        `${Math.max(
                          11,
                          resolvedTextSize -
                            2
                        )}px`,
                    }}
                  >
                    {subtitle}
                  </div>
                ) : null}


                {showStatus ? (
                  <div
                    className="mt-1 flex items-center gap-2 text-orange-100/80"
                    style={{
                      fontSize:
                        `${Math.max(
                          10,
                          resolvedTextSize -
                            3
                        )}px`,
                    }}
                  >

                    <span
                      className="h-2 w-2 rounded-full"
                      style={{
                        background:
                          complementaryColor,
                      }}
                    />


                    <span>
                      {botName}
                    </span>


                    <span>
                      •
                    </span>


                    <span>
                      {status}
                    </span>

                  </div>
                ) : null}

                {showStatus && agentIdentity ? (
                  <div
                    className="mt-0.5 truncate font-semibold text-orange-50/90"
                    style={{ fontSize: `${Math.max(10, resolvedTextSize - 3)}px` }}
                  >
                    {agentIdentity}
                  </div>
                ) : null}

              </div>

            </div>


            <div className="flex items-center gap-2">

              {showReset ? (
                <button
                  type="button"
                  onClick={
                    onReset
                  }
                  className="inline-flex items-center gap-2 rounded-2xl border border-white/20 bg-white/10 px-3 py-2 text-xs font-medium text-white transition hover:bg-white/15"
                >
                  <ResetGlyph />

                  {resetLabel}
                </button>
              ) : null}


              {onClose ? (
                <button
                  type="button"
                  onClick={
                    onClose
                  }
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white/90 transition hover:bg-white/15 hover:text-white"
                  aria-label="Close bot preview"
                  title="Close"
                >
                  <CloseGlyph />
                </button>
              ) : null}

            </div>

          </div>

        </div>
      ) : null}


      {/* =================================================
          CHAT AREA
      ================================================= */}

      <div
        ref={
          scrollRef
        }
        className="flex-1 min-h-0 space-y-4 overflow-y-auto overflow-x-hidden px-4 py-4"
        style={{
          background:
            chatBg,
        }}
      >

        {/* TODAY */}

        <div className="flex justify-center">

          <div
            className="rounded-full px-4 py-1 text-[12px] font-medium"
            style={{
              background:
                dateBg,

              color:
                subtleText,
            }}
          >
            Today
          </div>

        </div>


        {/* MESSAGES */}

        <AnimatePresence
          initial={
            false
          }
        >

          {renderedMessages.map(
            (
              message,
              index
            ) => (

              <motion.div
                key={
                  message.key
                }
                initial={{
                  opacity:
                    0,

                  y:
                    12,

                  scale:
                    0.98,
                }}
                animate={{
                  opacity:
                    1,

                  y:
                    0,

                  scale:
                    1,
                }}
                transition={{
                  duration:
                    0.22,

                  delay:
                    Math.min(
                      index *
                        0.04,
                      0.25
                    ),

                  ease:
                    'easeOut',
                }}
              >

                {/* USER */}

                {message.role ===
                'user' ? (

                  <Bubble
                    role="user"
                    primaryColor={
                      primaryColor
                    }
                    accentColor={
                      accentColor
                    }
                    themeMode={
                      themeMode
                    }
                    textSize={
                      resolvedTextSize
                    }
                    textColor={
                      resolvedTextColor
                    }
                  >
                    <div className="mt-1 whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
                      {
                        message.text
                      }
                    </div>
                  </Bubble>

                ) : (

                  /* BOT */

                  <div className="flex min-w-0 w-full items-end gap-3">

                    {message.startsGroup ? (

                      <div
                        className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full border bg-white text-[11px] font-semibold shadow-sm"
                        style={{
                          borderColor:
                            panelBorder,

                          color:
                            primaryColor,
                        }}
                      >
                        {avatarUrl ? (
                          <img
                            src={resolveAvatarUrl(avatarUrl)}
                            alt=""
                            className="h-full w-full object-cover"
                            onError={(e) => {
                              e.currentTarget.style.display = 'none';
                              if (e.currentTarget.nextSibling) {
                                e.currentTarget.nextSibling.style.display = 'inline';
                              }
                            }}
                          />
                        ) : null}
                        <span style={{ display: avatarUrl ? 'none' : 'inline' }}>
                          {avatarText}
                        </span>
                      </div>

                    ) : (

                      <div className="h-9 w-9 shrink-0" />

                    )}


                    <Bubble
                      role="bot"
                      wide={
                        Boolean(
                          message.mediaUrl
                        )
                      }
                      primaryColor={
                        primaryColor
                      }
                      accentColor={
                        accentColor
                      }
                      themeMode={
                        themeMode
                      }
                      textSize={
                        resolvedTextSize
                      }
                      textColor={
                        resolvedTextColor
                      }
                    >

                      <MediaContent
                        message={
                          message
                        }
                        themeMode={
                          themeMode
                        }
                      />


                      {message.text ? (
                        <div className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
                          <BotMessageText text={message.text} />
                        </div>
                      ) : null}

                    </Bubble>

                  </div>

                )}

              </motion.div>

            )
          )}

        </AnimatePresence>


        {/* =================================================
            TYPING
        ================================================= */}

        {typing ? (

          <motion.div
            initial={{
              opacity:
                0,

              y:
                10,
            }}
            animate={{
              opacity:
                1,

              y:
                0,
            }}
            transition={{
              duration:
                0.18,
            }}
            className="flex items-end gap-3"
          >

            <div
              className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white text-[11px] font-semibold shadow-sm"
              style={{
                border:
                  `1px solid ${panelBorder}`,

                color:
                  primaryColor,
              }}
            >
              {avatarUrl ? (
                <img
                  src={resolveAvatarUrl(avatarUrl)}
                  alt=""
                  className="h-full w-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    if (e.currentTarget.nextSibling) {
                      e.currentTarget.nextSibling.style.display = 'inline';
                    }
                  }}
                />
              ) : null}
              <span style={{ display: avatarUrl ? 'none' : 'inline' }}>
                {avatarText}
              </span>
            </div>


            <div
              className="rounded-[24px] rounded-bl-[8px] px-4 py-3 shadow-sm"
              style={{
                border:
                  `1px solid ${panelBorder}`,

                background:
                  panelBg,

                color:
                  resolvedTextColor,
              }}
            >
              <TypingDots />
            </div>

          </motion.div>

        ) : null}


        {/* =================================================
            QUICK REPLIES
        ================================================= */}

        {quickReplies?.length >
        0 ? (

          <div className="space-y-2 pl-12">

            {quickReplies.map(
              (
                reply,
                index
              ) => {

                // Supports:
                // "Option 1"
                //
                // and:
                // {
                //   title: "Option 1",
                //   value: "option_1"
                // }

                const isObject =
                  reply &&
                  typeof reply ===
                    'object';


                const replyTitle =
                  isObject
                    ? (
                        reply.title ||
                        reply.label ||
                        reply.text ||
                        reply.value ||
                        ''
                      )
                    : String(
                        reply
                      );


                const replyValue =
                  isObject
                    ? (
                        reply.value ||
                        reply.text ||
                        reply.title ||
                        reply.label ||
                        ''
                      )
                    : reply;


                return (
                  <motion.button
                    key={
                      `${
                        replyValue
                      }-${index}`
                    }
                    type="button"
                    whileHover={{
                      y:
                        -1,
                    }}
                    whileTap={{
                      scale:
                        0.98,
                    }}
                    onClick={() =>
                      onQuickReply(
                        preserveQuickReplyPayload && isObject
                          ? reply
                          : replyValue
                      )
                    }
                    className="flex min-w-0 w-full items-center justify-center whitespace-normal break-words rounded-[14px] px-4 py-2.5 text-center text-sm font-semibold shadow-sm transition [overflow-wrap:anywhere]"
                    style={{
                      border:
                        `1px solid ${panelBorder}`,

                      background:
                        panelBg,

                      color:
                        resolvedTextColor,

                      fontSize:
                        `${resolvedTextSize}px`,
                    }}
                  >
                    {
                      replyTitle
                    }
                  </motion.button>
                );
              }
            )}

          </div>

        ) : null}

      </div>


      {/* =================================================
          INPUT SECTION
      ================================================= */}

      <div
        className="border-t px-4 py-3"
        style={{
          borderColor:
            panelBorder,

          background:
            panelBg,
        }}
      >

        {/* =================================================
            DATE CALENDAR
        ================================================= */}

        {
          inputType ===
            'date' &&
          datePickerOpen
            ? (
                <PreviewDateCalendar
                  month={
                    calendarMonth
                  }
                  value={
                    inputValue
                  }
                  validation={
                    dateValidation
                  }
                  onMonthChange={
                    setCalendarMonth
                  }
                  onSelect={(
                    dateValue
                  ) => {

                    onInputChange(
                      dateValue
                    );

                    setDatePickerOpen(
                      false
                    );


                    // IMPORTANT:
                    // valid calendar selection automatically submits
                    onSend(
                      dateValue
                    );
                  }}
                  themeMode={
                    themeMode
                  }
                  primaryColor={
                    primaryColor
                  }
                />
              )
            : null
        }


        {/* =================================================
            MESSAGE FORM
        ================================================= */}

        <form
          onSubmit={
            handleSubmit
          }
          className="flex items-center gap-3"
        >

          {/* HOME */}

          {showHome ? (
          <motion.button
            type="button"
            whileHover={{
              scale:
                1.03,
            }}
            whileTap={{
              scale:
                0.97,
            }}
            onClick={
              onHome
            }
            className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full shadow-sm transition"
            style={{
              border:
                `1px solid ${panelBorder}`,

              background:
                themeMode ===
                'dark'
                  ? '#111827'
                  : '#f8fafc',

              color:
                subtleText,
            }}
            title="Open default journey"
          >
            <HomeGlyph />
          </motion.button>
          ) : null}


          {/* INPUT */}

          <div
            className="flex min-w-0 flex-1 items-center gap-2 rounded-full px-3 py-0.5 shadow-sm"
            style={{
              border:
                `1px solid ${panelBorder}`,

              background:
                panelBg,
            }}
          >

            <input
              ref={
                inputRef
              }
              type={
                inputType === 'date'
                  ? 'text'
                  : inputType
              }
              value={
                inputValue
              }
              onChange={(
                event
              ) =>
                onInputChange(
                  event.target.value
                )
              }
              onClick={() => {

                if (
                  inputType ===
                  'date'
                ) {
                  setDatePickerOpen(
                    true
                  );
                }

              }}
              placeholder={
                placeholder
              }
              className="min-w-0 flex-1 rounded-full bg-transparent px-1 py-2.5 text-sm outline-none"
              style={{
                color:
                  resolvedTextColor,

                fontSize:
                  `${resolvedTextSize}px`,
              }}
            />


            {/* ATTACHMENT */}

            {
              inputType ===
              'date'
                ? null
                : (
                  <>
                    <button
                      type="button"
                      onClick={() => attachmentInputRef.current?.click()}
                      className="inline-flex h-9 w-9 items-center justify-center rounded-full transition"
                      style={{
                        color:
                          subtleText,
                      }}
                      title="Attachment"
                    >
                      <AttachGlyph />
                    </button>
                    <input
                      ref={attachmentInputRef}
                      type="file"
                      hidden
                      accept="image/jpeg,image/png,image/webp,application/pdf,text/plain,.doc,.docx,audio/mpeg,audio/wav,audio/ogg"
                      onChange={(event) => {
                        const file = event.target.files?.[0];
                        event.target.value = '';
                        if (!file) return;
                        if (file.size > 10 * 1024 * 1024) {
                          window.alert('Attachment must be 10 MB or smaller.');
                          return;
                        }
                        if (typeof onAttachment === 'function') onAttachment(file);
                        else onSend(`Uploaded file: ${file.name}`, { uploaded_file: { name: file.name, mimeType: file.type, size: file.size, preview: true } });
                      }}
                    />
                  </>
                  )
            }

          </div>


          {/* SEND */}

          <motion.button
            type="submit"
            whileHover={{
              scale:
                1.02,
            }}
            whileTap={{
              scale:
                0.98,
            }}
            className="inline-flex h-11 min-w-[88px] items-center justify-center rounded-full px-5 text-sm font-semibold text-white shadow-lg transition"
            style={{
              background:
                `linear-gradient(90deg, ${primaryColor} 0%, ${accentColor} 100%)`,

              boxShadow:
                `0 12px 24px ${primaryColor}33`,

              fontSize:
                `${resolvedTextSize}px`,
            }}
          >
            Send
          </motion.button>

        </form>


        {/* =================================================
            FOOTER
        ================================================= */}

        {footerHint ? (

          <div
            className="mt-3 break-words text-[11px] leading-5 [overflow-wrap:anywhere]"
            style={{
              color:
                subtleText,
            }}
          >
            {
              footerHint
            }
          </div>

        ) : null}

        {showWatermark ? (
          <div className="mt-2.5 flex items-center justify-center gap-1 text-[11px] font-medium tracking-wide">
            <span style={{ color: subtleText }}>Powered by</span>
            <a
              href={watermarkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold transition hover:underline"
              style={{
                color: primaryColor || (themeMode === 'dark' ? '#38bdf8' : '#2563eb'),
              }}
            >
              Zelorich
            </a>
          </div>
        ) : null}

      </div>

    </div>
  );
}
